/**
 * Frontend
 */

import Colors from "../../../common/constant/colors";
import { Fonts } from "../../../common/constant/fonts";
import { guid, randOf } from "../../../common/helpers/generators";
import { hexToHsl, hslToHex } from "../../../common/helpers/palette";
import * as Styles from "./styles";
import Compile from "../../../common/components/builder/Compile";

import * as API from "../api";

/**
 *
 * @param {Object} Variables - filled in the form (WizardForm)
 * @param {Array|Object} Structure - generated (Structure)
 * @param {Object} options demo (default: false)
 * @returns {Promise} { variables: {}, structure: [] }
 */
export default function Generate(Variables = {}, Structure = [], options = { demo: false }) {
    return new Promise(resolve => {
        const { generated, blocks, info } = Compile(Structure);

        const font = randOf(Object.keys(Fonts));

        let color;
        let svgBg;
        let withGradient;

        GenerateColor(Variables.color)
            .then(newColor => (color = newColor))
            .then(() => GenerateSvgBg())
            .then(() => Continue());

        function GenerateSvgBg() {
            const primary = color.userPrimary ?? color.primary;
            const secondary = color.userSecondary ?? color.secondary;

            return (!options?.demo ? API.SvgBg : API.SvgBgDemo)(primary, secondary, info).then(response => {
                if (response.ok === false) {
                    console.log(`Generate() > GenerateSvgBg():`, response);
                    return;
                }

                svgBg = response.url;
                withGradient = response.withGradient;
            });
        }

        function Continue() {
            const structure = generated;

            const variables2block = getVariables2Blocks(structure);

            const variables = {
                id: guid(),
                dateCreated: Date.now(),
                dateModified: null,

                ...Variables,
                variables2block,

                dateModified: Date.now(),

                blocks,
                info,

                color,
                font,
                svgBg,

                eStyles: {
                    withGradient,

                    buttons: Styles.buttons(),
                },
            };

            resolve({ variables, structure });
        }
    });
}

/**
 *
 * @param {Object} Color - primary, secondary, userPrimary (optional)
 * @returns {Promise} { primary: "#ffffff", secondary: "#cccccc", userPrimary (if passed) }
 */
export function GenerateColor(Color = { primary: null, secondary: null }) {
    return new Promise(resolve => {
        const color = {
            ...Color,
            primary: null,
            secondary: null,
        };

        // Primary
        const primaryHex = randOf(Colors).hex;

        color.primary = primaryHex;

        // Secondary
        const primaryHSL = hexToHsl(color.userPrimary ?? color.primary);
        const secondaryHex = hslToHex(
            primaryHSL.h + randOf([-360, 360]) / 10,
            Math.min(100, primaryHSL.s + 5),
            Math.min(100, primaryHSL.l + 5)
        );

        color.secondary = secondaryHex;

        resolve(color);
    });
}

// Helpers ------------------------------------------------------------------ //
function getVariables2Blocks(structure) {
    let variables2block = [];

    for (const child of structure[0].children) {
        let id, name, _child;

        if (child.name === "Block") {
            id = child.children[0].props.id;
            name = child.children[0].name;
            _child = child.children[0];
        } else {
            id = child.props.id;
            name = child.name;
            _child = child;
        }

        variables2block.push({
            id,
            name,
            variables: { ...getAddVariables(_child) },
        });
    }

    return variables2block;

    function getAddVariables(child) {
        const addVariables = {};

        if (child.name === "BlockHeader") {
            addVariables.ProductType = child.props.ProductType;
        }

        if (child.name === "BlockOffers") {
            addVariables.BusinessGoal = child.props.BusinessGoal;
        }

        return addVariables;
    }
}
